import { Coordinates, TrackingOrderInfo, TrackingProduct } from "../types"
import { getSuperRegion } from "./regionUtils"
import { track } from "./analytics"

export const trackOrderComplete = async (
  userId: string,
  email: string,
  coords: Coordinates | null,
  orderInfo: TrackingOrderInfo,
  product: TrackingProduct,
  chargeId: string,
  state: string,
) => {
  const superRegion = await getSuperRegion(coords)

  track("Order Completed", {
    uid: userId,
    userEmail: email,
    email,
    superRegion,
    conversionValue: orderInfo.conversionValue || orderInfo.amountDollars,
    value: orderInfo.amountDollars,
    revenue: orderInfo.amountDollars,
    total: orderInfo.amountDollars,
    revenueType: orderInfo.revenueType || null,
    orderCategory: product.hasCourse ? "course" : "lesson",
    deliveryDate: orderInfo.deliveryDate || null,
    orderId: chargeId, // this just needs to be any unique ID
    order_id: chargeId, // for google ads
    transaction_id: chargeId, // for google ads
    state,
    products: [
      {
        productId: product.id,
        name: product.title,
        category: orderInfo.category,
        price: orderInfo.amountDollars,
        revenue: orderInfo.amountDollars,
        quantity: 1,
      },
    ],
  })
}
